import {
  Organization,
} from "model/organizationModel";
import createContext, { Action } from "./createDataContext";
import { DispatchAction } from "./createDataContext";
import { CONSTANTS } from "common";

const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
const SET_SELECTED_ORGANIZATION = "SET_SELECTED_ORGANIZATION";
const RESET_ORGANIZATIONS = "RESET_ORGANIZATIONS";
const SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION =
  "SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION";

const INITIAL_STATE = {
  organizationsUserId: null as number | null,
  organizations: [] as Organization[],
  selectedOrganization: null as Organization | null,
};

const getCurrentUserId = (): number | null => {
  const user = JSON.parse(localStorage.getItem(CONSTANTS.STORE_USER) || "null");
  return user?.userId ?? null;
};

const getSelectedOrganizationStorageKey = () => {
  const user = JSON.parse(localStorage.getItem(CONSTANTS.STORE_USER) || "null");
  return user?.userId
    ? `${CONSTANTS.STORE_SELECTED_ORGANIZATION_ID}-${user.userId}`
    : CONSTANTS.STORE_SELECTED_ORGANIZATION_ID;
};

const alignSelectedToLocal = (selectedOrganization: Organization | null) => {
  const storageKey = getSelectedOrganizationStorageKey();
  if (selectedOrganization?.id) {
    localStorage.setItem(
      storageKey,
      String(selectedOrganization.id),
    );
  } else {
    localStorage.removeItem(storageKey);
  }
};
const reducer = (state: typeof INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case SET_ORGANIZATIONS: {
      return {
        ...state,
        organizations: action.payload.organizations,
        organizationsUserId: action.payload.organizationsUserId,
        selectedOrganization: null,
      };
    }
    case SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION: {
      const { organizations, selectedOrganization, organizationsUserId } =
        action.payload;
      alignSelectedToLocal(selectedOrganization);
      return {
        ...state,
        organizations,
        selectedOrganization,
        organizationsUserId,
      };
    }
    case SET_SELECTED_ORGANIZATION: {
      const selectedOrganization = action.payload as Organization;
      alignSelectedToLocal(selectedOrganization);
      return { ...state, selectedOrganization: action.payload };
    }
    case RESET_ORGANIZATIONS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};

const setOrganizations: DispatchAction<Organization[], void> =
  (dispatch) => (organizations) => {
    const organizationsUserId = getCurrentUserId();
    const localSelectedOrganizationId = localStorage.getItem(
      getSelectedOrganizationStorageKey(),
    );
    const selectedOrganization = organizations.find(
      (o) => String(o.id) === localSelectedOrganizationId,
    );
    if (selectedOrganization) {
      dispatch({
        type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
        payload: {
          organizations,
          selectedOrganization,
          organizationsUserId,
        },
      });
    } else {
      if (organizations.length > 0) {
        dispatch({
          type: SET_ORGANIZATIONS_AND_SELECTED_ORGANIZATION,
          payload: {
            organizations,
            selectedOrganization: organizations[0],
            organizationsUserId,
          },
        });
      } else {
        dispatch({
          type: SET_ORGANIZATIONS,
          payload: { organizations, organizationsUserId },
        });
      }
    }
  };
const setSelectedOrganization: DispatchAction<Organization | null, void> =
  (dispatch) => (selectedOrganization) => {
    dispatch({
      type: SET_SELECTED_ORGANIZATION,
      payload: selectedOrganization,
    });
  };
const resetOrganizations: DispatchAction<void, void> =
  (dispatch) => () => {
    dispatch({ type: RESET_ORGANIZATIONS });
  };

const actions = {
  setOrganizations,
  setSelectedOrganization,
  resetOrganizations,
  // ACTIONS
};
type ActionsType = typeof actions;
export type ContextType = {
  state: typeof INITIAL_STATE;
  actions: {
    [Property in keyof ActionsType]: ReturnType<ActionsType[Property]>;
  };
};
export const { Context, Provider } = createContext<
  ContextType,
  typeof INITIAL_STATE,
  typeof actions
>(reducer, actions, INITIAL_STATE);
